/* Compact nav tile · sits on /division/tdb · CTA to open the master.
 * Also surfaces a quick count of pending approvals so Dipali sees
 * the queue depth without navigating in. */
import { useEffect, useState } from 'react';
import { Beaker, ChevronRight, ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';

export default function TDBIngredientMasterTile({ className = '' }) {
  const [pendingCount, setPendingCount] = useState(0);
  const [activeCount, setActiveCount] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const [a, b] = await Promise.all([
          api.get('/tdb-mis/ingredient-master'),
          api.get('/tdb-mis/ingredient-master/pending-approvals'),
        ]);
        if (!alive) return;
        setActiveCount(
          (a.data?.ingredients || []).filter((i) => i.active).length,
        );
        setPendingCount(b.data?.count || 0);
      } catch (e) {
        // ignore · tile is non-essential
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <button
      data-testid="tdb-ingredient-master-tile"
      onClick={() => navigate('/tdb/ingredient-master')}
      className={`w-full bg-white border border-violet-200 rounded-2xl p-4 text-left hover:bg-violet-50 transition group ${className}`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 rounded-lg bg-violet-100 text-violet-700 flex items-center justify-center shrink-0">
            <Beaker className="w-5 h-5" />
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="text-sm font-semibold text-slate-900">
                Ingredient Master · Rate Editor
              </h3>
              <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-violet-100 text-violet-800 font-medium uppercase tracking-wider">
                v2 pack · live
              </span>
              {pendingCount > 0 && (
                <span
                  data-testid="tdb-im-tile-pending-count"
                  className="text-[10px] px-1.5 py-0.5 rounded-full bg-amber-200 text-amber-900 font-medium flex items-center gap-1"
                >
                  <ShieldAlert className="w-3 h-3" />
                  {pendingCount} approval{pendingCount === 1 ? '' : 's'} pending
                </span>
              )}
            </div>
            <p className="text-xs text-slate-500 mt-0.5 truncate">
              {activeCount !== null ? `${activeCount} ingredients · ` : ''}
              edit rates here · cascade to every recipe + SKU instantly · &gt;±20% needs Dipali approval
            </p>
          </div>
        </div>
        <ChevronRight className="w-4 h-4 text-slate-400 group-hover:text-violet-700 shrink-0" />
      </div>
    </button>
  );
}
